module.exports = __webpack_public_path__ + "img/area-rounded.66001e63.svg";